import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

const InputSkeleton = () => <Skeleton variant="rectangular" height={40} />;

const ModalSkeleton = () => (
  <Grid container spacing={1}>
    <Grid size={12}>
      <InputSkeleton />
    </Grid>
    <Grid size={12}>
      <InputSkeleton />
    </Grid>
    <Grid size={12}>
      <InputSkeleton />
    </Grid>
    <Grid size={12}>
      <InputSkeleton />
    </Grid>
    <Grid size={12}>
      <InputSkeleton />
    </Grid>
  </Grid>
);

export default ModalSkeleton;
